import { CoordinatorService } from './coordinator.service';
import { Stage } from './stage';

export class ScriptStage {
    #coords: CoordinatorService;
    #_stage: Stage;

    constructor(coords: CoordinatorService, _stage: Stage) {
        this.#coords = coords;
        this.#_stage = _stage;
    }

    async widgetAsync(widgetId: string) {
        if (this.#_stage !== this.#coords.stage$.current) {
            this.display();
        }
        let w;
        let counter = 0;
        while (!w) {
            w = this.#coords.script$.widgetGet(widgetId);
            if (w) return w;
            await this.#coords.utils$.wait(0.5);
            if (counter++ > 10) break;
        }
        return w;
    }

    widget(widgetId: string) {
        return this.#coords.script$.widgetGet(widgetId);
    }

    off() {
        this.#_stage.isOff = true;
        this.#coords.display$.markForCheck();
    }

    on() {
        this.#_stage.isOff = false;
        this.#coords.display$.markForCheck();
    }

    current = this.display;
    display(tabId?: string) {
        if (this.#_stage !== this.#coords.stage$.current) this.#coords.stage$.set(this.#_stage);
        if (tabId) this.#_stage.setTab(tabId);
        return this;
    }

    log(prefix = 'Stage') {
        console.log(`${prefix}: ${this.#_stage.tag}`);
        return this;
    }
}
